
import { Challenge } from '../../types/game';
import { equipmentShortageChallenge } from './equipment-shortage';
import { regulatoryCrackdownChallenge } from './regulatory-crackdown';
import { bitcoinHalvingChallenge } from './bitcoin-halving';
import { coolingFailureChallenge } from './cooling-failure';
import { powerOpportunityChallenge } from './power-opportunity';
import { hardwareUpgradeChallenge } from './hardware-upgrade';
import { securityBreachChallenge } from './security-breach';
import { marketVolatilityChallenge } from './market-volatility';
import { expansionOpportunityChallenge } from './expansion-opportunity';
import { talentShortageChallenge } from './talent-shortage';

// Export all challenges as an array
export const challenges: Challenge[] = [
  equipmentShortageChallenge,
  regulatoryCrackdownChallenge,
  bitcoinHalvingChallenge,
  coolingFailureChallenge,
  powerOpportunityChallenge,
  hardwareUpgradeChallenge,
  securityBreachChallenge,
  marketVolatilityChallenge,
  expansionOpportunityChallenge,
  talentShortageChallenge
];
